module.exports = __webpack_public_path__ + "img/dark-logo.898a7beb.svg";